import React, {useEffect, useRef, useState} from 'react';
import {mrbgStore, selectTagValue, setActivePopups} from './mrbgRedux/index.js';
import humanStyle from '../../static/css/MP_human.module.css'

function MrbgHumanSelectArea(){

	const
		svgList = useRef(null),
		[activePopup,setActivePopup] = useState(mrbgStore.getState().activePopups.fullPU),
		[activeForms,setActiveForms] = useState(mrbgStore.getState().activeForms),
		[formID,setFormID] = useState(undefined),
		[svgAreaInfo,setSvgAreaInfo] = useState(mrbgStore.getState().mrbgVars.svgAreaInfo),
		[areTree,setAreTree] = useState(mrbgStore.getState().mrbgVars.areTree),
		[legAndHand,setLegAndHand] = useState({}),
		[areaName,setAreaName] = useState(mrbgStore.getState().mrbgVars.areFull__ST),
		[packageInfo,setPackageInfo] = useState(mrbgStore.getState().mrbgVars.packageInfo||[]),
		[values, setValues] = useState([]),
		[individualArea,setIndividualArea] = useState(new Set()),
		[gender,setGender] = useState('خانم'),
		[angle,setAngle] = useState({'خانم':0,'آقا':0}),
		[width,setWidth] = useState(null);

	function clickArea( val ){
		var valueSet = new Set(values);
		if( val ){
			if( valueSet.has(val) ){
				valueSet.delete(val);
				mrbgStore.dispatch(selectTagValue({ formID, STName:'areID', value: [...valueSet] }))
			}
			else if( formID!=='arePac' && individualArea.has(val) ){
				individualArea.delete(val);
				mrbgStore.dispatch(selectTagValue({ formID, STName:'areID', value: findBestMode([...individualArea]) }))
			}
			else
				mrbgStore.dispatch(selectTagValue({ formID, STName:'areID', value: [...valueSet.add(val)] }));
		}
	}
	function clickPackage( packID ){
		if( packID ){
			var valueSet = new Set( values );
			if( valueSet.has(packID) ){
				valueSet.delete(packID);
				mrbgStore.dispatch(selectTagValue({ formID, STName:'areID', value: [...valueSet] }));
			}
			else
				mrbgStore.dispatch(selectTagValue({ formID, STName:'areID', value: [...valueSet.add   (packID)] }));
		}
	}
	function removeTag( val ){
		mrbgStore.dispatch(selectTagValue({formID, STName:'areID', value:values.filter(item => item!=val)}));
	}
	function findBestMode( value ){

		var
			individual            = [],
			individualChild       = [],
			individualAndHisChild = [],
			primaryPack           = {};

		value.map(id=>{
			if( Object.hasOwn(packageInfo[gender],id) ){
				primaryPack[id] = [...packageInfo[gender][id].areID];
				var tempArray = [];
				packageInfo[gender][id].areID.map(areID=>{
					individual.push(areID);
					tempArray = [...tempArray,...Object.values(areTree[gender][areID].child)];
				})
				individualChild = [...individualChild,...tempArray];
			}
			else if( Object.hasOwn(areTree[gender],id) ){
				individual.push(id);
				individualChild = [...individualChild,...Object.values(areTree[gender][id].child)];
			}
		})


		var l = legAndHand[gender]?.legPart && legAndHand[gender].legPart.arrayDiff(individual);
		if( l?.length===0 ){
			let ch = Object.values(areTree[gender][legAndHand[gender].leg].child);
			individual      = [...individual,legAndHand[gender].leg];
			individualChild = [...individualChild,...ch];
		}

		var h = legAndHand[gender]?.handPart && legAndHand[gender].handPart.arrayDiff(individual);
		if( h?.length===0 ){
			let ch = Object.values(areTree[gender][legAndHand[gender].hand].child);
			individual      = [...individual,legAndHand[gender].hand];
			individualChild = [...individualChild,...ch];
		}

		individual            = [...new Set(individual.arrayDiff(individualChild))];
		individualAndHisChild = [...new Set([...individual,...individualChild])];

		var
			newVal = [...individual],
			len = newVal.length,
			possibleModes = {};

		if( formID!=='arePac' && len>=2 ){
			Object.keys(packageInfo[gender]).map(packID=>{
				if(
					packageInfo[gender][packID].areID.arrayDiff(individualAndHisChild).length===0 &&
					// WHEN THE AREAS OF TWO PACKAGES ARE EXACTLY THE SAME AND THE USER HAS CHOSEN THE MORE EXPENSIVE PACKAGE, DO NOT CONSIDER THE CHEAPER PACKAGE TO DETERMINE THE POSSIBLE MODES.
					(
						Object.hasOwn(primaryPack,packID.toString()) ||
						!Object.keys(primaryPack).some(prmPID =>{
							return(
								JSON.stringify(packageInfo[gender][packID].areID) === JSON.stringify(primaryPack[prmPID]) &&
								packageInfo[gender][packID].price < packageInfo[gender][prmPID].price
							)
						})
					)
				){
					let
						pArea   = packageInfo[gender][packID].areID,
						pAmount = parseInt(packageInfo[gender][packID].price),
						iArea   = individual.arrayDiff( packageInfo[gender][packID].areID ),
						iAmount = 0;
					if( iArea.includes(legAndHand[gender].leg) ){
						let LP = legAndHand[gender].legPart.intersect( pArea );
						if( LP.length ){
							LP = legAndHand[gender].legPart.arrayDiff( pArea );
							iArea.removeItem( legAndHand[gender].leg );
							iArea = [...iArea,...LP];
						}
					}
					if( iArea.includes(legAndHand[gender].hand) ){
						let HP = legAndHand[gender].handPart.intersect( pArea );
						if( HP.length ){
							HP = legAndHand[gender].handPart.arrayDiff( pArea );
							iArea.removeItem( legAndHand[gender].hand );
							iArea = [...iArea,...HP];
						}
					}
					iArea.map(id=> iAmount+=areTree[gender][id].price )
					possibleModes[packID] = {pArea,iArea,pAmount,iAmount}
				}
				else if(packageInfo[gender][packID].areID.arrayDiff(individualAndHisChild).length===0){
					console.log(packID+' IGNORE',primaryPack,Object.hasOwn(primaryPack,packID))
				}
			})
			possibleModes = findAllModes( possibleModes, individual );

			if( Object.keys(possibleModes).length ){
				var bestMode = undefined;
				Object.keys(possibleModes).map(k=>{
					if( !bestMode || possibleModes[k].pAmount+possibleModes[k].iAmount<possibleModes[bestMode].pAmount+possibleModes[bestMode].iAmount )
						bestMode = k;
				})
				newVal     = [...bestMode.split('#'),...possibleModes[bestMode].iArea];
				individual = [...possibleModes[bestMode].pArea,...possibleModes[bestMode].iArea];
				individualChild = [];
				individual.map(id => individualChild = [...individualChild,...Object.values(areTree[gender][id].child)])
				individual = individual.arrayDiff( individualChild )
			}
		}

		setIndividualArea( new Set(individual) );
		return newVal;
	}
	function findAllModes( possibleModes, individual ){
		var
			keys = Object.keys(possibleModes),
			len  = keys.length;

		for(let i=0; i<len; i++){
			for(let j=i+1; j<len; j++){
				if( (possibleModes[keys[j]].pArea.intersect(possibleModes[keys[i]].pArea)).length === 0 ){
					var newItemKey = `${keys[i]}#${keys[j]}`.split('#').arrayUnique().sort().join('#');
					if( !Object.hasOwn(possibleModes,newItemKey) ){
						var
							pArea   = [...possibleModes[keys[i]].pArea, ...possibleModes[keys[j]].pArea],
							pAmount = possibleModes[keys[i]].pAmount + possibleModes[keys[j]].pAmount,
							iArea   = individual.arrayDiff( pArea ),
							iAmount = 0;
						possibleModes[newItemKey] = {pArea,iArea,pAmount,iAmount};
					}
				}
			}
		}

		if( Object.keys(possibleModes).length!==len )
			possibleModes = findAllModes( possibleModes, individual );

		return possibleModes;
	}

	useEffect(() => {
		const observer = new ResizeObserver(entries => {
			for( let entry of entries )
				setWidth(entry.contentRect.width);
		});

		if( svgList.current )
			observer.observe(svgList.current);

		return () => observer.disconnect();
	}, [activePopup]);
	useEffect(()=>{
		if( activeForms?.includes('apoResFrame') )
			setFormID('apoRes');
		else if( activeForms?.includes('apoResUpdFrame') )
			setFormID('apoResUpd');
		else if( activeForms?.includes('arePacFrame') )
			setFormID('arePac');
	},[activeForms])
	useEffect(() => {
		if( formID ){
			const unsubscribe = mrbgStore.subscribe(()=>{
				setValues(mrbgStore.getState().formsSettings[formID]?.STV['areID'] || [])
			})
			return () =>unsubscribe();
		}
	}, [formID]);
	useEffect(() => {
		var LH = {
			'خانم': {
				leg: null,
				legPart: [],
				hand: null,
				handPart: []
			},
			'آقا': {
				leg: null,
				legPart: [],
				hand: null,
				handPart: []
			}
		};
		Object.keys(svgAreaInfo).map(gndr=>{
			Object.keys(svgAreaInfo[gndr].Front).map(k=>{
				if( svgAreaInfo[gndr].Front[k].svgAreaName=='leg' && svgAreaInfo[gndr].Front[k]?.areID )
					LH[gndr].leg = svgAreaInfo[gndr].Front[k].areID.toString();
				else if( svgAreaInfo[gndr].Front[k].svgAreaName=='hand' && svgAreaInfo[gndr].Front[k]?.areID )
					LH[gndr].hand = svgAreaInfo[gndr].Front[k].areID.toString();
				else if( ['thigh','knee','lower leg'].includes(svgAreaInfo[gndr].Front[k].svgAreaName) && svgAreaInfo[gndr].Front[k]?.areID )
					LH[gndr].legPart.push(svgAreaInfo[gndr].Front[k].areID.toString());
				else if( ['arm','elbow','forearm'].includes(svgAreaInfo[gndr].Front[k].svgAreaName) && svgAreaInfo[gndr].Front[k]?.areID )
					LH[gndr].handPart.push(svgAreaInfo[gndr].Front[k].areID.toString());
			})
		})
		setLegAndHand( LH );
	}, [svgAreaInfo]);
	useEffect(()=>{

		if( values.length ){
			var id = values[0];
			if( !gender || (!Object.hasOwn(areTree[gender],id) && !Object.hasOwn(packageInfo[gender],id)) ){
				gender==='خانم'?
					setGender('آقا'):
					setGender('خانم');
				return;
			}
		}

		var valueSet = new Set( findBestMode(values) );

		if( values.some(v=> !valueSet.has(v)) )
			mrbgStore.dispatch(selectTagValue({ formID, STName:'areID', value:[...valueSet] }))
	},[values,gender])
	useEffect(()=>{
		const unsubscribe = mrbgStore.subscribe(()=>{
			setActivePopup( mrbgStore.getState().activePopups.fullPU );
			setSvgAreaInfo( mrbgStore.getState().mrbgVars.svgAreaInfo );
			setAreTree    ( mrbgStore.getState().mrbgVars.areTree );
			setAreaName   ( mrbgStore.getState().mrbgVars.areFull__ST );
			setPackageInfo( mrbgStore.getState().mrbgVars.packageInfo );
			setActiveForms( mrbgStore.getState().activeForms );
		})
		return () =>unsubscribe();
	},[]);

	if( activePopup!=='areaSelectionFrame')
		return <div id={humanStyle.areaSelectionFrame}></div>

	else{
		return (
			<div id={humanStyle.areaSelectionFrame} className={humanStyle.active}>
				<i id={humanStyle.cross} className="fa-solid fa-close" onClick={()=>mrbgStore.dispatch(setActivePopups({fullPU:null}))}></i>
				<div id={humanStyle.selectionPart}>
					<div id={humanStyle.changeGender}>
						<i className="fa-solid fa-caret-right" onClick={()=>setGender(gender=='خانم'? 'آقا':'خانم')}></i>
						<span>{gender}</span>
						<i className="fa-solid fa-caret-left" onClick={()=>setGender(gender=='خانم'? 'آقا':'خانم')}></i>
					</div>
					<div id={humanStyle.selectionOptions}>
						{
							formID!=='arePac'?
								<div id={humanStyle.packageFrame}>
									<h4>لیست پکیج ها</h4>
									<ul>
										{
											Object.keys(packageInfo[gender]).map((packID,k)=>{
												return <li className={values.includes(packID)? humanStyle.selected:''} onClick={()=>clickPackage(packID)} key={k}>{packageInfo[gender][packID].name}</li>
											})
										}
									</ul>
								</div>:
								''
						}
						<div className={humanStyle.svgListFrame}>
							<i className="fa-solid fa-caret-right" onClick={() => setAngle({...angle,[gender]:angle[gender]+120})}></i>
							<ul className={humanStyle.svgList} ref={svgList}>
								{
									Object.keys(svgAreaInfo).map((gnd,i)=>{
										return(
											<li style={{transform:`translateX(${gender=='آقا'? 100: 0}%)`}} key={i}>
												<div style={{transform:`translateZ(${Math.ceil(width/(-2*Math.tan(Math.PI/3)))}px) rotateY(${angle[gnd]}deg)`}}>
													{
														Object.keys(svgAreaInfo[gnd]).map((side,j)=>{
															return(
																<svg id={humanStyle.wonamFront} viewBox={`0 0 ${gender=='خانم'? '200 620':'240 710'}`} xmlns="http://www.w3.org/2000/svg" key={j} style={{transform:`rotateY(${j*-360/3}deg) translateZ(${Math.floor(width/(2*Math.tan(Math.PI/3)))}px)`}}>
																	{
																		svgAreaInfo[gnd][side].map((info,k)=>{
																			if( info.areID )
																				return (
																					<g key={k}>
																						<path className={`${humanStyle[info.className]} ${individualArea.has(info.areID.toString())? humanStyle.selected: ''}`} d={info.d} pathLength="1" onClick={() => clickArea(info.areID.toString())}></path>
																						{info.wrinkleD && <path className={`${humanStyle.wrinkleD}`} d={info.wrinkleD} onClick={() => clickArea(info.areID.toString())}></path>}
																						<title>{info.name}</title>
																					</g>
																				)
																			else if( info.wrinkleD )
																				return <path className={humanStyle.wrinkleD} d={info.wrinkleD} key={k}></path>
																			else
																				return <path className={humanStyle[info.className]} d={info.d} key={k}></path>
																		})
																	}
																</svg>
															)
														})
													}
												</div>
											</li>
										)
									})
								}
							</ul>
							<i className="fa-solid fa-caret-left" onClick={() => setAngle({...angle,[gender]:angle[gender]-120})}></i>
						</div>
					</div>
				</div>
				<div id={humanStyle.selectedArea}>
					<h3>برگزیدن ناحیه</h3>
					<div>
						<h4>نواحی انتخاب شده</h4>
						{
							values.length?
								values.map(( val, i ) => {
									return (
										<label className={humanStyle.mrbgTag} key={i}>
											{areaName[val]}
											<i className="fa-regular fa-times-circle" onClick={() => removeTag(val)}></i>
										</label>
									)
								}):
								''
						}
					</div>
				</div>
			</div>
		)
	}
}

export default MrbgHumanSelectArea;